import React, { forwardRef, useRef } from 'react'
import PropTypes from 'prop-types'

export const LoginButton = forwardRef(
  ({ as = 'button', onClick, ...rest }, ref) => {
    const internalRef = useRef(null)
    const Comp = as
    const forwardedRef = ref ? ref : internalRef
    return (
      <Comp
        className="dev_dash__login-button"
        onClick={onClick}
        ref={forwardedRef}
        {...rest}
      />
    )
  },
)

LoginButton.displayName = 'LoginButton'
LoginButton.propTypes = {
  as: PropTypes.any,
  onClick: PropTypes.func,
}
